import React from 'react';
import { useToastStore, Toast as ToastType } from '../../stores/toastStore';

const TYPE_STYLES: Record<ToastType['type'], string> = {
  success: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  error: 'border-red-200 bg-red-50 text-red-700',
  warning: 'border-amber-200 bg-amber-50 text-amber-700',
  info: 'border-purple-200 bg-purple-50 text-purple-700',
};

function ToastItem({ toast, onDismiss }: { toast: ToastType; onDismiss: () => void }) {
  return (
    <div
      className={`
        ${TYPE_STYLES[toast.type]}
        border rounded-lg px-4 py-3 font-mono text-sm
        shadow-lg animate-slide-in flex items-center gap-3 min-w-[280px] max-w-[420px]
      `}
    >
      <span className="flex-1">{toast.message}</span>
      <button
        onClick={onDismiss}
        className="text-gray-400 hover:text-gray-600 transition-colors text-xs"
      >
        x
      </button>
    </div>
  );
}

export function ToastContainer() {
  const { toasts, remove } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={() => remove(toast.id)} />
      ))}
    </div>
  );
}
